<template>
  <div class="acts background-gradient" v-if="activitytypeList.length > 0">
    <div class="pageTop">{{ $t('Promotions') }}</div>
    
    <!-- 【修改点 1】：加上 :swipe-threshold="1" 强制开启横向滚动 -->
    <van-tabs v-model="actType" class="topsa" @click="activitylist" :swipe-threshold="1">
      <van-tab :title="$t('All Promotions')" :name="''"> </van-tab>
      <van-tab v-for="(item, index) in activitytypeList" :name="item.id" :title="getDynamicTabName(item.name)" :key="index"> </van-tab>
    </van-tabs>
    
    <div class="consg">
      <div class="lis" v-for="(item, index) in activitylistList" :key="index" @click="$parent.goNav(`/activityInfo?id=${item.id}`)">
        <div class="activity-wrapper">
          <img :src="item.banner" :alt="$t('Activity Banner')" class="activity-banner" />
          <img :src="getActivityTypeIcon(item)" alt="" class="activity-type-icon" v-if="getActivityTypeIcon(item)" />
        </div>
      </div>
      <van-divider dashed :style="{ color: '#9a8b7e', borderColor: '#e5d8c8', padding: '20px 16px' }">{{ $t('END') }}</van-divider>
    </div>
  </div>
</template>

<script>
export default {
  name: 'activity',
  data() {
    return {
      activitytypeList: [],
      actType: '',
      activitylistList: [],
    };
  },
  created() {
    let that = this;
    that.activitytype();
    that.activitylist();
  },
  methods: {
    getDynamicTabName(name) {
      const map = {
        '限时活动': 'Limited Time Offer',
        '新人福利': 'Newbie Benefits'
      };
      const key = map[name] || name;
      return this.$t(key);
    },
    
    activitytype() {
      let that = this;
      that.$apiFun.post('/api/activitytype', {}).then(res => {
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitytypeList = res.data;
        }
      });
    },
    activitylist() {
      let that = this;
      let info = that.actType == '' ? {} : { type: that.actType };
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitylist', info).then(res => {
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitylistList = res.data.data;
        }
        that.$parent.hideLoading();
      });
    },
    changActType(val) {
      let that = this;
      if (val == that.actType) {
        return;
      }
      that.actType = val;
      that.activitylist();
    },
    getActivityTypeIcon(item) {
      let that = this;
      let imgSrc = '';
      
      const activityIconFields = [
        'activity_type_icon', 'type_icon', 'icon', 'image', 'img', 
        'type_image', 'type_img', 'activity_icon', 'activity_image', 'activity_img',
        'logo', 'thumb', 'thumbnail', 'pic', 'picture', 'banner_type',
        'type_banner', 'icon_url', 'img_url', 'image_url'
      ];
      
      for (const field of activityIconFields) {
        if (item[field] && item[field].trim() !== '') {
          imgSrc = item[field].trim();
          break;
        }
      }
      
      if (!imgSrc && item.type !== undefined) {
        let type = that.activitytypeList.find(t => 
          t.id == item.type || 
          t.name == item.type ||
          t.type == item.type
        );
        
        if (type) {
          const typeIconFields = [
            'icon', 'image', 'img', 'logo', 'thumb', 'thumbnail', 
            'pic', 'picture', 'banner', 'icon_url', 'img_url', 'image_url'
          ];
          
          for (const field of typeIconFields) {
            if (type[field] && type[field].trim() !== '') {
              imgSrc = type[field].trim();
              break;
            }
          }
        }
      }
      
      if (imgSrc) {
        let baseURL = window.location.origin.replace(/\/+$/, '');
        let result = '';
        if (/^(data:|blob:|\/\/|https?:\/\/)/i.test(imgSrc)) {
          result = imgSrc;
        } else if (imgSrc.startsWith('/uploads/')) {
          result = baseURL + imgSrc;
        } else if (imgSrc.startsWith('/')) {
          if (!imgSrc.includes('/uploads/')) {
            result = baseURL + '/uploads' + imgSrc;
          } else {
            result = baseURL + imgSrc;
          }
        } else {
          result = baseURL + '/uploads/' + imgSrc;
        }
        return result;
      }
      return '';
    },
  },
  mounted() {},
  updated() {},
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
/* 白色游戏平台主题 */
.background-gradient {
  background: #ffffff;
  min-height: 100vh;
  box-sizing: border-box;
  color: #2d241d;
}

/* 顶部金棕导航 */
.pageTop {
  background: linear-gradient(135deg, #603514 0%, #965723 58%, #bd7a38 100%);
  color: white;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 201;
  box-shadow: 0 5px 16px rgba(96, 53, 20, 0.22);
}

/* 标签栏外部容器 */
.topsa {
  position: fixed;
  top: 50px; /* 紧贴顶部标题栏下方 */
  left: 0;
  width: 100%;
  z-index: 200;
  background-color: #fff;
  padding: 12px 10px 8px;
  border-bottom: 1px solid #eadfd2;
  box-shadow: 0 5px 14px rgba(104, 69, 36, 0.07);
  box-sizing: border-box;
}

/* Vant Tab 深度自定义 */
.topsa ::v-deep .van-tabs__nav {
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0;
  margin-left: 5px;
  
  /* 【修改点 2】：确保内容超出可以滑动，并隐藏滚动条 */
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; 
  scrollbar-width: none; /* Firefox */
}

/* 隐藏 Chrome/Safari 滚动条 */
.topsa ::v-deep .van-tabs__nav::-webkit-scrollbar {
  display: none;
}

/* 未选中的 Tab */
.topsa ::v-deep .van-tab {
  flex: 0 0 auto !important;
  padding: 0 20px !important;
  height: 34px;
  line-height: 34px;
  background: #fbf7f1 !important;
  color: #7c6e62;
  border-radius: 20px; /* 胶囊形状 */
  border: 1px solid #eadfd2;
  margin-right: 12px;
  transition: all 0.3s ease;
  
  /* 【修改点 3】：强制文字不换行，撑开盒子宽度 */
  white-space: nowrap; 
}

/* 选中的 Tab */
.topsa ::v-deep .van-tab--active {
  background: linear-gradient(135deg, #f7e2ad, #dca84f) !important;
  color: #633713 !important;
  font-weight: 700;
  border: 1px solid #d6a248;
  box-shadow: 0 4px 10px rgba(171, 104, 40, 0.18);
}

.topsa ::v-deep .van-tab__text {
  font-size: 14px;
}

.topsa ::v-deep .van-tabs__line {
  display: none; /* 隐藏默认底边线 */
}

/* 列表容器 */
.consg {
  padding-top: 115px; /* 躲避头部标题(50px) + 标签栏(~65px) */
  padding-bottom: 90px; /* 躲避底部菜单 */
  padding-left: 15px;
  padding-right: 15px;
  
  .lis {
    margin-bottom: 20px;
    background-color: #fff;
    border-radius: 16px;
    box-shadow: 0 8px 22px rgba(104, 69, 36, 0.11);
    border: 1px solid #eadfd2;
    overflow: hidden;
    cursor: pointer;
    
    .activity-wrapper {
      position: relative;
      width: 100%;
      
      .activity-banner {
        width: 100%;
        min-height: 120px; /* 防止未加载时塌陷 */
        height: auto;
        display: block;
        object-fit: cover;
        background: #f8f3ed;
      }
      
      .activity-type-icon {
        position: absolute;
        top: 10px;
        left: -8px;
        width: 70px;
        height: 50px;
        z-index: 10;
        filter: drop-shadow(0 3px 5px rgba(96, 53, 20, 0.24));
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/activity.vue